import { defineStore } from 'pinia';
import { ref, watch, computed } from 'vue';

export const useEditorControlsStore = defineStore('editorControls', () => {
  const selectedLabel = ref(null);
  const drawMode = ref('pointer');
  const current3DCanvasTool = ref('3d-pointer');

  const drawCursorSize = ref(0);
  const doneVertexDraw = ref(false);

  function $reset() {
    selectedLabel.value = null;
    drawMode.value = 'pointer';
    current3DCanvasTool.value = '3d-pointer';
    drawCursorSize.value = 0;
    doneVertexDraw.value = false;
  }

  function updateCursorSize(v) {
    drawCursorSize.value = v;
  }

  return {
    selectedLabel,
    drawMode,
    current3DCanvasTool,
    drawCursorSize,
    doneVertexDraw,
    $reset,
    updateCursorSize,
  };
});
